import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faRupeeSign,
  faClock,
  faCalendar
} from '@fortawesome/free-solid-svg-icons';
import { formatDate, formatTime } from '../../utils/helper.js';
import '../../css/icon-detail.css';

const IconDetail = ({ icon, type, value }) => {
  let iconToUse = icon ? icon : '';
  let formattedValue = value;
  if (!icon) {
    switch (type) {
      case 'date': {
        iconToUse = faCalendar;
        formattedValue = formatDate(value);
        break;
      }
      case 'time': {
        iconToUse = faClock;
        formattedValue = formatTime(value);
        break;
      }
      case 'cost': {
        iconToUse = faRupeeSign;
        break;
      }
      default:
        break;
    }
  }

  return (
    <div className="icon-detail">
      <span className="icon">
        <FontAwesomeIcon icon={iconToUse}></FontAwesomeIcon>
      </span>
      <span>{formattedValue}</span>
    </div>
  );
};

export default IconDetail;
